import { render, staticRenderFns } from "./DuvalView.vue?vue&type=template&id=6f2e51b8&scoped=true&"
import script from "./DuvalView.vue?vue&type=script&lang=js&"
export * from "./DuvalView.vue?vue&type=script&lang=js&"
import style0 from "./DuvalView.vue?vue&type=style&index=0&id=6f2e51b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e51b8",
  null
  
)

export default component.exports